import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useLaborCostDetailsCardController } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/labor-cost-details/useLaborCostDetailsCardController.ts";
import { DateStyle } from "@/shared/utils/Dates.ts";
import { LaborCostDetailsTable } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/labor-cost-details/LaborCostDetailsTable.tsx";
import "./LaborCostDetailsCard.scss";
import { CircularProgress } from "@mui/material";

export default function LaborCostDetailsCard(): ReactNode {
  const { t } = useTranslation(["common", "humanResources"]);

  const controller = useLaborCostDetailsCardController();
  if (!controller.isEnabled) return undefined;

  function formatDateOrRange(): string {
    if (controller.range === "DAY") {
      return t("common:date", {
        date: controller.startDate,
        style: DateStyle.WEEKDAY_DATE_MONTH_YEAR,
      });
    } else {
      return t("common:dateSpan", {
        start: controller.startDate,
        end: controller.endDate,
        style: DateStyle.WEEKDAY_DATE_MONTH_YEAR,
      });
    }
  }

  return (
    <div className="labor-cost-details-card">
      <div className="card-header">
        <div className="card-title">
          {t("humanResources:timeManagement.analysis.calculationDetails")}
        </div>
        <div className="card-date">{formatDateOrRange()}</div>
      </div>
      <div className="card-body">
        {controller.isFetching ?
          <CircularProgress />
        : <LaborCostDetailsTable sections={controller.sections} />}
      </div>
    </div>
  );
}
